import { firestore } from '../../contexts/FirebaseContext';

export const getUserNip = async (idUser) => {
  const userNip = await (await firestore.collection('users').doc(idUser).get()).data().nip;

  return userNip;
};
